import React from 'react';
import * as PropTypes from 'prop-types';
import HeadlineItem from '../../../component/HeadlineItem';
import './style.scss';

const Recommendation = (
  {
    data,
    onLike,
    onUnlike,
    onShare
  }
) => {
  if (!data || data.length === 0) return null;

  const handleShareClick = (config, articleId) => {
    onShare(config, articleId);
  };

  return (
    <article className="recommendation">
      <section className="recommendation-header">
        <div className="recommendation-header-line" />
        <h3>更多推荐</h3>
        <div className="recommendation-header-line" />
      </section>
      <ul>
        {
          data.map((item, index) => {
            const {
              articleId
            } = item;
            const key = `${articleId}-${index}`;
            return (
              <HeadlineItem
                key={key}
                data={item}
                onShare={handleShareClick}
                onLike={onLike}
                onUnlike={onUnlike}
              />
            );
          })
        }
      </ul>
    </article>
  );
};

Recommendation.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  onShare: PropTypes.func.isRequired,
  onLike: PropTypes.func.isRequired,
  onUnlike: PropTypes.func.isRequired
};

export default Recommendation;
